import LocalStorageSupport from '../web/LocalStorageSupport';

export default function() {
	const ls = new LocalStorageSupport();
	if (ls.getItem('KM_GA_DIMENSION_BABY_AGE') && ls.getItem('KM_GA_DIMENSION_BABY_AGE') != 'null') {
		let age = Math.round((new Date() - new Date(ls.getItem('KM_GA_DIMENSION_BABY_AGE'))) / (3600 * 1000 * 24 * 30));
		age = (age >=36) ? '36+' : age;
		/*dataLayer.push({
			"Baby age": age
		});*/
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/gtm-event/dimension-child-age.js